<template>
  <div>
    <QueryFrame
      :count="count"
      :current="page"
      add-text="handlePermission('billsTimeAdd') ? '单据时间修改' : ''"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      @addNew="addNew">
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>创建时间:</label>
            <timeStampDatePicker class="item" v-model="query.createTime" clearable></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>单据类型:</label>
            <lk-select
              class="item"
              v-model="query.bizType"
              clearable
              placeholder="请选择">
              <lk-option v-for="(item) in bizTypeList" :key="item.value" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>修改类型:</label>
            <lk-select
              class="item"
              v-model="query.type"
              clearable
              placeholder="请选择">
              <lk-option v-for="(item) in chageTypeList" :key="item.value" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>单据号:</label>
            <lk-input
              class="item"
              v-model.trim="query.billNo"
              clearable
              maxlenth="100">
            </lk-input>
          </div>
          <div class="queryItem">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="handleReset">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
    <operate-log v-model="showLog" :logList="logData"/>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import toolsService from '../../services/tools';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import OperateLog from '../../components/operateLog';

// 接口信息
export default {
  name: 'billsTimeList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    OperateLog,
  },
  data() {
    return {
      query: {
		    createTime: '',
		    bizType: '',
        type: '',
        billNo: '',
        storeIdList: [],
      },
		  bizTypeList: [
        {
        	value: 1,
        	name: '销售订单',
        },
        {
          value: 2,
          name: '销售退货单',
        },
        {
          value: 3,
          name: '验收单',
        },
        {
          value: 4,
          name: '供应商退货单',
        },
        {
          value: 5,
          name: '应付单',
        },
        {
          value: 6,
          name: '采购计划单',
        },
        {
          value: 7,
          name: '采购订单',
        },
        {
          value: 8,
          name: '收货单',
        },
      ], // 单据类型
		  chageTypeList: [
        {
        	value: 1,
          name: '创建',
        },
        {
          value: 2,
          name: '审核',
        },
      ], // 修改类型
      showLog: false,
      columns: [
        {
          title: '序号',
          type: 'index',
          minWidth: 80,
          indexMethod: row => (row._index + this.size * (this.page - 1)) + 1,
        },
        { title: '单据类型', key: 'bizTypeName', minWidth: 116 },
        { title: '修改类型', key: 'type', minWidth: 116 },
        { title: '单据号', key: 'bizNo', minWidth: 116 },
        { title: '原日期', key: 'createTime', minWidth: 116 },
        { title: '修改后日期', key: 'createTime', minWidth: 116 },
        { title: '创建人', key: 'createUserName', minWidth: 116 },
        { title: '创建时间', key: 'createTimeStr', minWidth: 116 },
        { title: '门店名称', key: 'storeName', minWidth: 116 },
        // {
        //   title: '操作',
        //   key: 'action',
        //   fixed: 'right',
        //   width: 130,
        //   render: (h, { row }) => (this.hasEditable ? h('lk-button', {
        //     props: {
        //       type: 'text',
        //       disabled: row.doubtfulCount === 0,
        //     },
        //     on: {
        //       click: () => {
        //         this.handleLog(row.id);
        //       },
        //     },
        //   }, '操作日志') : null),
        // },
      ],
      tableData: [],
      logData: [],
    };
  },
  computed: {
    hasEditable() {
      return this.handlePermission('goodsPrimaryKeyOperateLog');
    },
  },
  methods: {
    handleReset() {
      this.query = {};
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;

      toolsService.getBillsTimeList(this.params).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          list.forEach((item) => {
            // const result = {};
            // utils.exchangeTable(item, result);
            item.createTimeStr = utils.formatTime(item.createTime); // 创建时间
          });
          this.count = count;
          this.tableData = list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    addNew() {
      this.$router.push({ name: 'billsTimeAdd' });
    },
    handleLog(id) {
      this.logData = [];
      this.showLog = true;
      this.$store.commit('setDisableLoading', true);
      toolsService.getGoodsPrimaryOperationLogList({ operateDetailId: id }).then((res) => {
        if (res.data.status === 200) {
          const data = res.data.data;
          const logItem = {
            content: `${utils.formatTime(data.createTime)}由 ${data.createUserName} ${data.contentList.join(';')}`,
          };
          this.logData.push(logItem);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    if (!this.hasEditable) {
      this.columns.pop();
    }
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
</style>
